import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import VisitorNavbar from "../../component/VisitorNavbar";
import Footer from "../../component/Footer";
import { baseurl, imageUrl } from "../../Baseurl";
import "../../component/css/service.css"; 
import Swal from 'sweetalert2';


// Helper function for phone masking
const maskPhoneNumber = (phone) => {
 if (!phone || phone.length < 3) return "N/A";
 const prefix = phone.slice(0, 3);
 return `${prefix}*******`;
};

// --- Form Component (FIXED) ---
const ServiceApplicationForm = ({ serviceManId, serviceManName, closeModal }) => {
 const [formData, setFormData] = useState({
  name: "",
  address: "",
  contact: "",
  email: "",
  instrumentName: "",
  modelNumber: "",
  technicalIssue: "",
 });
 const [docAttachment, setDocAttachment] = useState(null);
 const [videoAttachment, setVideoAttachment] = useState(null);
 const [submissionStatus, setSubmissionStatus] = useState(""); // success, error, submitting
 const [validationErrors, setValidationErrors] = useState({});

 const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
 };

 const handleFileChange = (e) => {
  const { name, files } = e.target;
  if (name === "docAttachment") {
   setDocAttachment(files[0]);
  } else if (name === "videoAttachment") {
   setVideoAttachment(files[0]);
  }
 };

 const validateForm = () => {
  let errors = {};
  // Validation Rules
  if (!formData.name) errors.name = "Name is required.";
  if (!formData.address) errors.address = "Address is required.";
  if (!formData.contact || !/^\d{10}$/.test(formData.contact)) errors.contact = "Valid 10-digit contact number is required.";
  if (!formData.email || !/\S+@\S+\.\S/.test(formData.email)) errors.email = "A valid email address is required.";
  if (!formData.instrumentName) errors.instrumentName = "Instrument Name is required.";
  
  const issueLength = formData.technicalIssue.length;
  if (!formData.technicalIssue || issueLength < 50 || issueLength > 500) {
      errors.technicalIssue = `Technical issue must be 50 to 500 characters long. (Currently ${issueLength})`;
  }
  
  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
 };

 // Make sure to import Swal if you haven't already

const handleSubmit = async (e) => {
e.preventDefault();

// STEP 1: Run client-side validation first
if (!validateForm()) {
 setSubmissionStatus("error");
 return;
}

setSubmissionStatus("submitting");

const formPayload = new FormData();
formPayload.append("serviceManId", serviceManId);
formPayload.append("serviceManName", serviceManName);
formPayload.append("seller_id", localStorage.getItem("seller_id"));
 
// Append customer data
Object.keys(formData).forEach(key => formPayload.append(key, formData[key]));

// Append files if they exist
if (docAttachment) formPayload.append("document", docAttachment);
if (videoAttachment) formPayload.append("video", videoAttachment);

// --- Console Log Sent Data ---
// console.log("--- Sending Service Application Request ---");
for (let pair of formPayload.entries()) {
 const [key, value] = pair;
 
 if (value instanceof File) {
  // Log file details (name, size, type)
  console.log(`Payload Field: ${key}: [File: ${value.name}, Size: ${value.size} bytes, Type: ${value.type}]`);
 } else {
  // Log non-file fields
  console.log(`Payload Field: ${key}: ${value}`);
 }
}
// console.log("-----------------------------------------");
// --- END: Console Log Sent Data ---


try {
const response = await axios.post(`${baseurl}applyService`, formPayload, {
 headers: {
 "Content-Type": "multipart/form-data",
 },
});

if (response.data.success) {
 setSubmissionStatus("success");
 
 // --- START: Swal Toast Notification on Success ---
 const Toast = Swal.mixin({
   toast: true,
   position: "top-end",
   showConfirmButton: false,
   timer: 3000,
   timerProgressBar: true,
   didOpen: (toast) => {
     toast.onmouseenter = Swal.stopTimer;
     toast.onmouseleave = Swal.resumeTimer;
   }
 });
 Toast.fire({
   icon: "success",
   title: "Request Sent Successfully!"
 });
 // --- END: Swal Toast Notification on Success ---
 
 // Automatically close modal after the toast duration (3000ms)
 setTimeout(() => {
 closeModal();
 }, 3000); 
 
 // Clear form state after success
 setFormData({
 name: "", address: "", contact: "", email: "", 
 instrumentName: "", modelNumber: "", technicalIssue: "",
 });
 setDocAttachment(null);
 setVideoAttachment(null);
 setValidationErrors({}); 
} else {
 setSubmissionStatus("error");
 console.error("Submission failed:", response.data.message);
 // You might consider using a Swal error message here too
 Swal.fire('Error', response.data.message || 'Service submission failed.', 'error');
}

} catch (error) {
setSubmissionStatus("error");
validateForm(); 
console.error("Error submitting service application:", error);

// Use Swal for network/fatal error notification
Swal.fire('Network Error', 'Could not connect to the server. Please try again later.', 'error');
}
};
 return (
  <form onSubmit={handleSubmit}>
    
   {/* Submission Status Alerts */}
   {submissionStatus === "submitting" && (
    <div className="alert alert-info d-flex align-items-center"><div className="spinner-border spinner-border-sm me-2"></div> Submitting request...</div>
   )}
   {submissionStatus === "success" && (
    <div className="alert alert-success"><i className="bi bi-check-circle me-2"></i> Service request submitted successfully! The provider will contact you soon.</div>
   )}
   {submissionStatus === "error" && (
    <div className="alert alert-danger"><i className="bi bi-exclamation-triangle me-2"></i> Submission failed. Please check the form for errors and try again.</div>
   )}

   {/* --- Customer Details --- */}
   <h6 className="text-muted border-bottom pb-2 mb-3"><i className="bi bi-person-lines-fill me-2"></i> Your Details</h6>
   
   <div className="row g-3 mb-3 text-start">
    <div className="col-md-6">
     <label htmlFor="name" className="form-label">Name <span className="text-danger">*</span></label>
     <input 
      type="text" 
      className={`form-control ${validationErrors.name ? 'is-invalid' : ''}`}
      id="name" 
      name="name" 
      value={formData.name} 
      onChange={handleChange} 
     />
     {validationErrors.name && <div className="invalid-feedback">{validationErrors.name}</div>}
    </div>
    <div className="col-md-6">
     <label htmlFor="email" className="form-label">Email ID <span className="text-danger">*</span></label>
     <input 
      type="email" 
      className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
      id="email" 
      name="email" 
      value={formData.email} 
      onChange={handleChange} 
     />
     {validationErrors.email && <div className="invalid-feedback">{validationErrors.email}</div>}
    </div>
    <div className="col-md-6">
     <label htmlFor="contact" className="form-label">Contact Details <span className="text-danger">*</span></label>
     <input 
      type="tel" 
      className={`form-control ${validationErrors.contact ? 'is-invalid' : ''}`}
      id="contact" 
      name="contact" 
      value={formData.contact} 
      onChange={handleChange} 
      maxLength="10"
      placeholder="e.g., 9876543210"
     />
     {validationErrors.contact && <div className="invalid-feedback">{validationErrors.contact}</div>}
    </div>
    <div className="col-12">
     <label htmlFor="address" className="form-label">Address <span className="text-danger">*</span></label>
     <textarea 
      className={`form-control ${validationErrors.address ? 'is-invalid' : ''}`}
      id="address" 
      name="address" 
      value={formData.address} 
      onChange={handleChange} 
      rows="2"
     />
     {validationErrors.address && <div className="invalid-feedback">{validationErrors.address}</div>}
    </div>
   </div>

   {/* --- Instrument Details --- */}
   <h6 className="text-muted border-bottom pb-2 mb-3"><i className="bi bi-gear-wide-connected me-2"></i> Instrument Details</h6>

   <div className="row g-3 mb-3">
    <div className="col-md-6">
     <label htmlFor="instrumentName" className="form-label">Instrument Name <span className="text-danger">*</span></label>
     <input 
      type="text" 
      className={`form-control ${validationErrors.instrumentName ? 'is-invalid' : ''}`}
      id="instrumentName" 
      name="instrumentName" 
      value={formData.instrumentName} 
      onChange={handleChange} 
     />
     {validationErrors.instrumentName && <div className="invalid-feedback">{validationErrors.instrumentName}</div>}
    </div>
    <div className="col-md-6">
     <label htmlFor="modelNumber" className="form-label">Model Number (Optional)</label>
     <input 
      type="text" 
      className="form-control" 
      id="modelNumber" 
      name="modelNumber" 
      value={formData.modelNumber} 
      onChange={handleChange} 
     />
    </div>
    <div className="col-12">
     <label htmlFor="technicalIssue" className="form-label">Technical Issue Description <span className="text-danger">*</span></label>
     <textarea 
      className={`form-control ${validationErrors.technicalIssue ? 'is-invalid' : ''}`}
      id="technicalIssue" 
      name="technicalIssue" 
      value={formData.technicalIssue} 
      onChange={handleChange} 
      rows="5"
      placeholder="Describe the issue in detail (5-10 lines, Min 50 characters)"
     />
     <small className="form-text text-muted">Characters: {formData.technicalIssue.length}</small>
     {validationErrors.technicalIssue && <div className="invalid-feedback">{validationErrors.technicalIssue}</div>}
    </div>
   </div>

   {/* --- Attachments --- */}
   <h6 className="text-muted border-bottom pb-2 mb-3"><i className="bi bi-paperclip me-2"></i> Optional Attachments</h6>

   <div className="row g-3 mb-4">
    <div className="col-md-6">
     <label htmlFor="docAttachment" className="form-label">Document/Photo (PDF, JPG, PNG)</label>
     <input 
      type="file" 
      className="form-control" 
      id="docAttachment" 
      name="docAttachment" 
      onChange={handleFileChange} 
      accept=".pdf,.jpg,.jpeg,.png"
     />
     <small className="form-text text-muted">Max file size: 5MB</small>
    </div>
    <div className="col-md-6">
     <label htmlFor="videoAttachment" className="form-label">Video (MP4, MOV)</label>
     <input 
      type="file" 
      className="form-control" 
      id="videoAttachment" 
      name="videoAttachment" 
      onChange={handleFileChange} 
      accept="video/mp4,video/mov"
     />
     <small className="form-text text-muted">Attach a video showing the issue.</small>
    </div>
   </div>

   {/* The submit button */}
   <button 
    type="submit" 
    className="btn btn-primary btn-lg w-100" 
    // disabled={submissionStatus === "submitting"}
   >
    <i className="bi bi-send me-2"></i> Submit Service Request
   </button>
  </form>
 );
};


// --- Main Service Profile Component ---
const ServiceProfile = () => {
 const { id } = useParams();
 const [serviceMan, setServiceMan] = useState(null);
 const [categoryPath, setCategoryPath] = useState([]);
 const [similarServiceMen, setSimilarServiceMen] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showModal, setShowModal] = useState(false); // State for modal visibility

 const fetchServiceManById = async () => {
  setLoading(true);
  try {
   const response = await axios.get(`${baseurl}getManById/${id}`);
   setServiceMan(response.data.data.serviceMan);
   setCategoryPath(response.data.data.serviceCategoryPath || []); 
   setSimilarServiceMen(response.data.data.similarServiceMen || []);
  } catch (error) {
   console.error("Error fetching service man profile:", error);
   setServiceMan(null);
  } finally {
   setLoading(false);
  }
 };

 useEffect(() => {
  if (id) fetchServiceManById();
 }, [id]);
 
 // Handlers for Modal
 const openModal = () => setShowModal(true);
 const closeModal = () => setShowModal(false);


 if (loading) return (
  <>
   <VisitorNavbar />
   <div className="container profile-container text-center py-5">
    <div className="spinner-border text-primary" role="status">
     <span className="visually-hidden">Loading...</span>
    </div>
    <p className="mt-2">Loading profile...</p>
   </div>
   <Footer />
  </>
 );

 if (!serviceMan) return (
  <>
   <VisitorNavbar />
   <div className="container profile-container text-center py-5">
    <div className="alert alert-danger" role="alert">
     No service provider profile found for ID: {id}.
    </div>
   </div>
   <Footer />
  </>
 );

 return (
  <>
   <VisitorNavbar />
   <div className="container profile-container py-5">
    
    {/* Breadcrumb */}
    {categoryPath.length > 0 && (
     <nav aria-label="breadcrumb" className="mb-4">
      <ol className="breadcrumb service-breadcrumb">
       {categoryPath.map((title, index) => (
        <li
         key={index}
         className={`breadcrumb-item ${index === categoryPath.length - 1 ? "active" : ""}`}
         aria-current={index === categoryPath.length - 1 ? "page" : undefined}
        >
         {title.trim()} 
        </li>
       ))}
      </ol>
     </nav>
    )}

    {/* --- Main Profile Section --- */}
    <div className="row g-4">
     <div className="col-lg-8">
      <div className="card shadow-lg profile-card-main p-4 mb-4">
       
       {/* Existing Profile Header (Image, Name, Experience) */}
       <div className="d-flex align-items-start">
        <div className="flex-shrink-0 me-4 text-center">
         <img
          src={
           serviceMan.profile_image
            ? `${imageUrl}servicefile/${serviceMan.profile_image}`
            : "https://via.placeholder.com/150?text=Profile+Image"
          }
          alt={serviceMan.name}
          className="profile-img-lg rounded-circle border border-5 border-light"
         />
        </div>
        
        <div className="flex-grow-1 profile-header-info">
         <h1 className="display-6 mb-1">{serviceMan.name || "Service Provider"}</h1>
         <p className="lead text-muted mb-3">
          {categoryPath.length > 0 ? categoryPath[categoryPath.length - 1].trim() : "Service Category"}
         </p>
         
         <div className="d-flex flex-wrap gap-4 mb-3">
          <p className="mb-0">
           <i className="bi bi-clock-history me-2"></i> 
           <strong>Experience:</strong> {serviceMan.experience || "N/A"}
          </p>
          <p className="mb-0">
           <i className="bi bi-telephone me-2"></i> 
           <strong>Contact:</strong> {maskPhoneNumber(serviceMan.phone)}
          </p>
         </div>
         
         <div className="d-flex flex-wrap gap-3">
          {/* Button to open the Service Application Modal */}
          <button 
            className="btn btn-primary btn-lg"
            onClick={openModal}
          >
           <i className="bi bi-tools me-2"></i> Book Service
          </button>

          {serviceMan.resume && (
           <a
            href={`${imageUrl}servicefile/${serviceMan.resume}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-secondary btn-lg"
           >
            <i className="bi bi-file-earmark-person me-2"></i> View Resume
           </a>
          )}
        </div>
        </div>
       </div>

       <hr className="my-4"/>

       <div className="about-section">
        <h4 className="mb-3"><i className="bi bi-info-circle me-2"></i> About {serviceMan.name ? serviceMan.name.split(' ')[0] : 'The Provider'}</h4>
        <p className="text-secondary">{serviceMan.about || "No detailed description provided by the service provider."}</p>
       </div>
      </div>

      {/* Business Details Section */}
      <div className="card shadow-sm business-details-card p-4 mt-4">
       <h4 className="mb-3"><i className="bi bi-briefcase me-2"></i> Business Details</h4>
       <table className="table table-hover details-table">
        <tbody>
         <tr><th>Business Name</th><td>{serviceMan.business_name || "N/A"}</td></tr>
         <tr><th>Business Email</th><td>{serviceMan.business_email || "N/A"}</td></tr>
         <tr><th>Contact Phone</th><td>{maskPhoneNumber(serviceMan.contact)}</td></tr>
         <tr><th>GST Number</th><td>{serviceMan.gst_number || "N/A"}</td></tr>
         <tr><th>Address</th><td>{serviceMan.business_address || "N/A"}</td></tr>
         <tr><th>City / State / Pincode</th><td>{serviceMan.city || "N/A"} / {serviceMan.state || "N/A"} / {serviceMan.pincode || "N/A"}</td></tr>
         <tr><th>Country</th><td>{serviceMan.country || "N/A"}</td></tr>
        </tbody>
       </table>
      </div>
     </div>

     {/* Right Column for Similar Profiles */}
     <div className="col-lg-4">
      {similarServiceMen.length > 0 && (
       <div className="card shadow-sm similar-profiles-card p-4 sticky-top-custom">
        <h4 className="mb-4 text-center"><i className="bi bi-people me-2"></i> Similar Providers</h4>
        <div className="list-group list-group-flush">
         {similarServiceMen.map((man) => (
          <Link 
           key={man.id} 
           to={`/service-profile/${man.id}`} 
           className="list-group-item list-group-item-action similar-profile-item"
           onClick={() => window.scrollTo(0, 0)} 
          >
           <div className="d-flex align-items-center">
            <img
             src={
              man.profile_image
               ? `${imageUrl}servicefile/${man.profile_image}`
               : "https://via.placeholder.com/50?text=P"
             }
             alt={man.name}
             className="profile-img-sm rounded-circle me-3"
            />
            <div>
             <h6 className="mb-0 text-primary">{man.name}</h6>
             <small className="text-muted">
              <i className="bi bi-telephone me-1"></i> {man.phone || "N/A"}
             </small>
            </div>
           </div>
          </Link>
         ))}
        </div>
       </div>
      )}
     </div>
    </div>

   </div>
   <Footer />
   
   {/* --- Service Application Modal --- */}
   {showModal && (
    <div 
     className="modal fade show" 
     style={{ display: 'block' }} 
     tabIndex="-1" 
     role="dialog"
     onClick={(e) => { 
      // Close modal only if clicking directly on the backdrop (the modal-dialog is a child)
      if (e.target.className.includes('modal fade show')) closeModal();
     }}
    >
     <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
      <div className="modal-content">
       <div className="modal-header">
        <h5 className="modal-title">
          <i className="bi bi-tools me-2 text-primary"></i> Request Service from {serviceMan.name}
        </h5>
        <button 
         type="button" 
         className="btn-close" 
         aria-label="Close" 
         onClick={closeModal}
        ></button>
       </div>
       <div className="modal-body p-4">
        <p className="alert alert-info small">
         Please fill out the form below with details about the issue. The service provider will contact you using the details provided.
        </p>
        <ServiceApplicationForm 
         serviceManId={id} 
         serviceManName={serviceMan.name || "Service Provider"} 
         closeModal={closeModal} // Pass the close function to the form
        />
       </div>
      </div>
     </div>
    </div>
   )}
   {/* Add a backdrop manually when modal is shown for visual effect */}
   {showModal && <div className="modal-backdrop fade show"></div>}
  </>
 );
};

export default ServiceProfile;